import { useLayoutEffect } from 'react'

import RadioXl from '../../../common/forms/Radio/RadioXl.tsx'

type Props = {
  optionSharingSelected: 'folder' | 'diet' | null
  setOptionSharing: (option: 'folder' | 'diet' | null) => void
}

const ToggleOptionSharing = (props: Props) => {
  const { optionSharingSelected, setOptionSharing } = props

    useLayoutEffect(() => {
      setOptionSharing('folder')
    }, [])

  const onChangeHandler = (e: any) => {
    setOptionSharing(e)
  }

  return (
    <div className={'flex items-center p-5 flex-col justify-center gap-x-4'}>
      <p className={'text-xl text-black dark:text-white font-medium pb-3'}>
        Chcę udostępnić:
      </p>
      <div className={'flex flex-col md:flex-row gap-x-4 gap-y-2'}>
        <RadioXl
          id={'radio-option-sharing-1'}
          name={'radio-option-sharing'}
          value={'folder'}
          label={'folder z dietami'}
          checked={optionSharingSelected === 'folder'}
          onChange={(e) => onChangeHandler(e)}
        />
        <RadioXl
          id={'radio-option-sharing-2'}
          name={'radio-option-sharing'}
          value={'diet'}
          label={'wybraną przeze mnie dietę'}
          checked={optionSharingSelected === 'diet'}
          onChange={(e) => onChangeHandler(e)}
        />
      </div>
    </div>
  )
}
  export default ToggleOptionSharing